"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4992,2920],{

/***/ 6978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lE": function() { return /* reexport */ hero_Hero1; }
});

// UNUSED EXPORTS: Hero10, Hero11, Hero12, Hero13, Hero14, Hero15, Hero16, Hero17, Hero18, Hero19, Hero1Para, Hero20, Hero21, Hero22, Hero23, Hero24, Hero25, Hero26, Hero27, Hero4, Hero5, Hero6, Hero7, Hero8, Hero9

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero1.tsx

var Hero1 = function(param) {
    var title = param.title, lead = param.lead, body = param.body, bgcolor = param.bgcolor;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "website-test",
        className: "wrapper bg-".concat(bgcolor),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container text-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row gx-lg-8 gx-xl-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 text-center text-lg-start mx-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row mx-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-lg-10 text-center text-lg-start mx-auto"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "lead fs-lg my-7 text-center",
                                children: lead
                            }),
                            body
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var hero_Hero1 = (Hero1);

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero1Para.tsx

var Hero1Para = function(param) {
    var title = param.title, lead = param.lead, body = param.body, src = param.src;
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container mt-5 mt-md-10 pt-15 pt-md-14 pb-8 text-center",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 offset-md-1 offset-lg-0 col-lg-6 text-center text-lg-start mx-auto",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "display-3 mb-3 text-center text-lg-start",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg my-7",
                                children: lead
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg",
                                children: body
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-6",
                        children: /*#__PURE__*/ _jsx("figure", {
                            children: /*#__PURE__*/ _jsx("img", {
                                width: 960,
                                height: 600,
                                src: "/img/".concat(src.toLowerCase().replace(/ /g, "-"), ".png"),
                                srcSet: "/img/".concat(src.toLowerCase().replace(/ /g, "-"), "@2x.png 2x"),
                                // srcSet={`/img/${src.replace(/ /g, '-').toLowerCase()}@2x.jpg 2x`}
                                alt: src,
                                style: {
                                    background: "transparent"
                                }
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero_Hero1Para = ((/* unused pure expression or super */ null && (Hero1Para)));

// EXTERNAL MODULE: ./src/components/reuseable/links/NextLink.tsx
var links_NextLink = __webpack_require__(9472);
;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero4.tsx



var Hero4 = function() {
    return /*#__PURE__*/ _jsxs("section", {
        className: "wrapper bg-light position-relative min-vh-70 d-lg-flex align-items-center",
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    backgroundImage: "url(/img/photos/about16.jpg)"
                },
                className: "rounded-4-lg-start col-lg-6 order-lg-2 position-lg-absolute top-0 end-0 image-wrapper bg-image bg-cover h-100 min-vh-50"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "container",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-6",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "mt-10 mt-md-11 mt-lg-n10 px-10 px-md-11 ps-lg-0 pe-lg-13 text-center text-lg-start",
                            children: [
                                /*#__PURE__*/ _jsx("h1", {
                                    className: "display-1 mb-5",
                                    style: slideInDownAnimate("600ms"),
                                    children: "Just sit & relax while we take care of your business needs."
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "lead fs-25 lh-sm mb-7 pe-md-10",
                                    style: slideInDownAnimate("900ms"),
                                    children: "We make your spending stress-free for you to have the perfect control."
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "d-flex justify-content-center justify-content-lg-start",
                                    style: slideInDownAnimate("900ms"),
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            style: slideInDownAnimate("1200ms"),
                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                href: "#",
                                                title: "Explore Now",
                                                className: "btn btn-lg btn-primary rounded-pill me-2"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            style: slideInDownAnimate("1500ms"),
                                            children: /*#__PURE__*/ _jsx(NextLink, {
                                                href: "#",
                                                title: "Contact Us",
                                                className: "btn btn-lg btn-outline-primary rounded-pill"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var hero_Hero4 = ((/* unused pure expression or super */ null && (Hero4)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero5.tsx



var Hero5 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pt-10 pb-15 pt-md-14 pb-md-20 text-center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-md-10 col-lg-8 col-xl-8 col-xxl-6 mx-auto mb-13",
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            className: "display-1 mb-4",
                            style: slideInDownAnimate("0ms"),
                            children: "Staying on top of your bills never been this easy"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "lead fs-lg px-xl-12 px-xxl-6 mb-7",
                            style: slideInDownAnimate("300ms"),
                            children: "Easily achieve your saving goals. Have all your recurring and one time expenses and incomes in one place."
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex justify-content-center",
                            style: slideInDownAnimate("600ms"),
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    style: slideInDownAnimate("900ms"),
                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                        href: "#",
                                        title: "Get Started",
                                        className: "btn btn-primary rounded mx-1"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    style: slideInDownAnimate("1200ms"),
                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                        href: "#",
                                        title: "Free Trial",
                                        className: "btn btn-green rounded mx-1"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var hero_Hero5 = ((/* unused pure expression or super */ null && (Hero5)));

// EXTERNAL MODULE: ./src/components/common/GoogleAppBtn.tsx
var common_GoogleAppBtn = __webpack_require__(1147);
;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero6.tsx




var Hero6 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-5 pb-15 py-lg-17 py-xl-19 pb-xl-20 position-relative",
            children: [
                /*#__PURE__*/ _jsx("img", {
                    alt: "hero",
                    src: "/img/photos/devices.png",
                    srcSet: "/img/photos/devices@2x.png 2x",
                    className: "position-lg-absolute col-12 col-lg-10 col-xl-11 col-xxl-10 px-lg-5 px-xl-0 ms-n5 ms-sm-n8 ms-md-n10 ms-lg-0 mb-md-4 mb-lg-0",
                    style: _object_spread({
                        top: "-1%",
                        left: "-21%"
                    }, fadeInAnimate("0ms"))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row gx-0 align-items-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 offset-md-1 col-lg-5 offset-lg-7 offset-xxl-6 ps-xxl-12 mt-md-n9 text-center text-lg-start",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "display-2 mb-4 mx-sm-n2 mx-md-0",
                                style: slideInDownAnimate("600ms"),
                                children: "Get all of your steps, exercise, sleep and meds in one place."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg mb-7 px-md-10 px-lg-0",
                                style: slideInDownAnimate("900ms"),
                                children: "SEOptimist is now available to download from both the App Store and Google Play Store."
                            }),
                            /*#__PURE__*/ _jsx(GoogleAppBtn, {})
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_Hero6 = ((/* unused pure expression or super */ null && (Hero6)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero7.tsx



var Hero7 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-gradient-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container py-14 pt-md-15 pb-md-18",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row text-center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-9 col-xxl-7 mx-auto",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "display-1 mb-4",
                                style: zoomInAnimate("0ms"),
                                children: "Creative. Smart. Awesome."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-24 lh-sm px-md-5 px-xl-15 px-xxl-10 mb-7",
                                style: zoomInAnimate("500ms"),
                                children: "We are an award winning web & mobile design agency that strongly believes in the power of creative ideas."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex justify-content-center",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            style: slideInDownAnimate("900ms"),
                            children: /*#__PURE__*/ _jsx(NextLink, {
                                href: "#",
                                title: "See Projects",
                                className: "btn btn-lg btn-primary rounded-pill mx-1"
                            })
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            style: slideInDownAnimate("1200ms"),
                            children: /*#__PURE__*/ _jsx(NextLink, {
                                href: "#",
                                title: "Contact Us",
                                className: "btn btn-lg btn-outline-primary rounded-pill mx-1"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row mt-12",
                    style: fadeInAnimate("1600ms"),
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-8 mx-auto",
                        children: /*#__PURE__*/ _jsx("figure", {
                            children: /*#__PURE__*/ _jsx("img", {
                                alt: "",
                                className: "img-fluid",
                                src: "/img/illustrations/i12.png",
                                srcSet: "/img/illustrations/i12@2x.png 2x"
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_Hero7 = ((/* unused pure expression or super */ null && (Hero7)));

// EXTERNAL MODULE: ./node_modules/react-countup/build/index.js
var build = __webpack_require__(7857);
// EXTERNAL MODULE: ./src/components/reuseable/IconBox.tsx
var reuseable_IconBox = __webpack_require__(220);
;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero8.tsx





var Hero8 = function() {
    return /*#__PURE__*/ _jsx("div", {
        className: "card bg-soft-primary rounded-4 mt-2 mb-13 mb-md-17",
        children: /*#__PURE__*/ _jsx("div", {
            className: "card-body p-md-10 py-xl-11 px-xl-15",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-0 gy-10 align-items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-6 order-lg-2 d-flex position-relative",
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                alt: "demo",
                                src: "/img/photos/co3.png",
                                srcSet: "/img/photos/co3@2x.png 2x",
                                className: "img-fluid ms-auto mx-auto me-lg-8",
                                style: fadeInAnimate("0ms")
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                style: animation({
                                    name: "slideInRight",
                                    delay: "600ms"
                                }),
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card shadow-lg position-absolute",
                                    style: {
                                        bottom: "10%",
                                        right: "-3%"
                                    },
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "card-body py-4 px-5",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex flex-row align-items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    children: /*#__PURE__*/ _jsx(IconBox, {
                                                        icon: "uil-users-alt",
                                                        className: "icon btn btn-circle btn-md btn-soft-primary pe-none mx-auto me-3"
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("h3", {
                                                            className: "counter mb-0 text-nowrap",
                                                            children: /*#__PURE__*/ _jsx(CountUp, {
                                                                end: 25000,
                                                                suffix: "+"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            className: "fs-14 lh-sm mb-0 text-nowrap",
                                                            children: "Happy Clients"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-6 text-center text-lg-start",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "display-2 mb-5",
                                style: slideInDownAnimate("600ms"),
                                children: "Crafting project specific solutions with expertise."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg lh-sm mb-7 pe-xl-10",
                                style: slideInDownAnimate("900ms"),
                                children: "We're a company that focuses on establishing long-term relationships with customers."
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex justify-content-center justify-content-lg-start",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1200ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Explore Now",
                                            href: "#",
                                            className: "btn btn-lg btn-primary rounded-pill me-2"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1500ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Contact Us",
                                            href: "#",
                                            className: "btn btn-lg btn-outline-primary rounded-pill"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero_Hero8 = ((/* unused pure expression or super */ null && (Hero8)));

// EXTERNAL MODULE: ./node_modules/typewriter-effect/dist/react.js
var react = __webpack_require__(5459);
;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero9.tsx




var Hero9 = function() {
    // typewriter options
    var OPTIONS = {
        loop: true,
        autoStart: true,
        strings: [
            "easy usage",
            "fast transactions",
            "secure payments"
        ]
    };
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pt-10 pb-12 pt-md-14 pb-md-17",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10 align-items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 offset-md-1 offset-lg-0 col-lg-5 mt-lg-n2 text-center text-lg-start order-2 order-lg-0",
                        children: [
                            /*#__PURE__*/ _jsxs("h1", {
                                className: "display-1 mb-5 mx-md-10 mx-lg-0",
                                style: slideInDownAnimate("600ms"),
                                children: [
                                    "SEOptimist is effortless and powerful with ",
                                    /*#__PURE__*/ _jsx("br", {}),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "typer text-primary text-nowrap",
                                        children: /*#__PURE__*/ _jsx(Typewriter, {
                                            options: OPTIONS
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg mb-7",
                                style: slideInDownAnimate("900ms"),
                                children: "Achieve your saving goals. Have all your recurring and one time expenses and incomes in one place."
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex justify-content-center justify-content-lg-start",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1200ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Get Started",
                                            href: "#",
                                            className: "btn btn-lg btn-primary rounded me-2"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1500ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Free Trial",
                                            href: "#",
                                            className: "btn btn-lg btn-green rounded"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-7",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "col-3 offset-1 offset-lg-0 col-lg-4 d-flex flex-column",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "ms-auto mt-auto",
                                            style: zoomInAnimate("300ms"),
                                            children: /*#__PURE__*/ _jsx("img", {
                                                className: "img-fluid rounded shadow-lg",
                                                src: "/img/photos/sa20.jpg",
                                                srcSet: "/img/photos/sa20@2x.jpg 2x",
                                                alt: "demo"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "ms-auto mt-5 mb-10",
                                            style: zoomInAnimate("600ms"),
                                            children: /*#__PURE__*/ _jsx("img", {
                                                className: "img-fluid rounded shadow-lg",
                                                src: "/img/photos/sa18.jpg",
                                                srcSet: "/img/photos/sa18@2x.jpg 2x",
                                                alt: "demo"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-4 col-lg-5",
                                    style: zoomInAnimate("0ms"),
                                    children: /*#__PURE__*/ _jsx("div", {
                                        children: /*#__PURE__*/ _jsx("img", {
                                            className: "w-100 img-fluid rounded shadow-lg",
                                            src: "/img/photos/sa16.jpg",
                                            srcSet: "/img/photos/sa16@2x.jpg 2x",
                                            alt: "demo"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "col-3 d-flex flex-column",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mt-auto",
                                            style: zoomInAnimate("300ms"),
                                            children: /*#__PURE__*/ _jsx("img", {
                                                alt: "demo",
                                                src: "/img/photos/sa21.jpg",
                                                srcSet: "/img/photos/sa21@2x.jpg 2x",
                                                className: "img-fluid rounded shadow-lg"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mt-5",
                                            style: zoomInAnimate("600ms"),
                                            children: /*#__PURE__*/ _jsx("img", {
                                                alt: "demo",
                                                src: "/img/photos/sa19.jpg",
                                                srcSet: "/img/photos/sa19@2x.jpg 2x",
                                                className: "img-fluid rounded shadow-lg"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mt-5 mb-10",
                                            style: zoomInAnimate("900ms"),
                                            children: /*#__PURE__*/ _jsx("img", {
                                                alt: "demo",
                                                src: "/img/photos/sa17.jpg",
                                                srcSet: "/img/photos/sa17@2x.jpg 2x",
                                                className: "img-fluid rounded shadow-lg"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero_Hero9 = ((/* unused pure expression or super */ null && (Hero9)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero10.tsx



var Hero10 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pt-11 pt-md-13 pb-11 pb-md-19 pb-lg-22 text-center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-lg-8 col-xl-7 col-xxl-6 mx-auto",
                    children: [
                        /*#__PURE__*/ _jsxs("h1", {
                            className: "display-1 fs-60 mb-4 px-md-15 px-lg-0",
                            style: slideInDownAnimate("0ms"),
                            children: [
                                "We bring solutions to make life ",
                                /*#__PURE__*/ _jsx("span", {
                                    className: "underline-3 style-3 primary",
                                    children: "easier"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "lead fs-24 lh-sm mb-7 mx-md-13 mx-lg-10",
                            style: slideInDownAnimate("300ms"),
                            children: "We are a creative company that focuses on long term relationships with customers."
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            style: slideInDownAnimate("600ms"),
                            children: /*#__PURE__*/ _jsx(NextLink, {
                                title: "Read More",
                                href: "#",
                                className: "btn btn-lg btn-primary rounded mb-5"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var hero_Hero10 = ((/* unused pure expression or super */ null && (Hero10)));

// EXTERNAL MODULE: ./src/components/reuseable/Carousel.tsx
var reuseable_Carousel = __webpack_require__(7632);
// EXTERNAL MODULE: ./src/hooks/useLightBox.ts
var hooks_useLightBox = __webpack_require__(9486);
;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero11.tsx


// -------- custom component -------- //


// -------- custom hook -------- //

var Hero11 = function() {
    // use video popup
    useLightBox();
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper image-wrapper bg-image bg-overlay bg-overlay-400 bg-content text-white",
        style: {
            backgroundImage: "url(/img/photos/bg4.jpg)"
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pt-18 pb-16",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-0 gy-12 align-items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 offset-md-1 offset-lg-0 col-lg-6 content text-center text-lg-start",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "display-2 mb-5 text-white",
                                style: slideInDownAnimate("600ms"),
                                children: "Crafting project specific solutions with expertise."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg lh-sm mb-7 pe-xl-10",
                                style: slideInDownAnimate("900ms"),
                                children: "We’re a creative company that focuses on establishing long-term relationships with customers."
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex justify-content-center justify-content-lg-start",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1200ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Explore Now",
                                            href: "#",
                                            className: "btn btn-lg btn-white rounded-pill me-2"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1500ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Contact Us",
                                            href: "#",
                                            className: "btn btn-lg btn-outline-white rounded-pill"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-5 offset-lg-1",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "swiper-container shadow-lg",
                            children: /*#__PURE__*/ _jsxs(Carousel, {
                                slidesPerView: 1,
                                className: "dots-over",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        alt: "",
                                        className: "rounded",
                                        src: "/img/photos/about21.jpg",
                                        srcSet: "/img/photos/about21@2x.jpg 2x"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx("a", {
                                                "data-glightbox": true,
                                                "data-gallery": "hero",
                                                href: "/media/movie.mp4",
                                                className: "btn btn-circle btn-white btn-play ripple mx-auto mb-5 position-absolute",
                                                style: {
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%,-50%)",
                                                    zIndex: 3
                                                },
                                                children: /*#__PURE__*/ _jsx("i", {
                                                    className: "icn-caret-right"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("img", {
                                                alt: "",
                                                className: "rounded",
                                                src: "/img/photos/about22.jpg",
                                                srcSet: "/img/photos/about22@2x.jpg 2x"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("img", {
                                        alt: "",
                                        className: "rounded",
                                        src: "/img/photos/about23.jpg",
                                        srcSet: "/img/photos/about23@2x.jpg 2x"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero_Hero11 = ((/* unused pure expression or super */ null && (Hero11)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero12.tsx



var Hero12 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pt-10 pb-15 pt-md-14 pb-md-20",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gx-lg-8 gx-xl-12 gy-10 mb-5 align-items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-10 offset-md-1 offset-lg-0 col-lg-5 text-center text-lg-start order-2 order-lg-0",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "display-1 mb-5 mx-md-n5 mx-lg-0",
                                style: slideInDownAnimate("600ms"),
                                children: "Creative. Smart. Awesome."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-lg mb-7",
                                style: slideInDownAnimate("900ms"),
                                children: "We specialize in web, mobile and identity design. We love to turn ideas into beautiful things."
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex justify-content-center justify-content-lg-start",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1200ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            href: "#",
                                            title: "See Projects",
                                            className: "btn btn-primary rounded me-2"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1500ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            href: "#",
                                            title: "Learn More",
                                            className: "btn btn-yellow rounded"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-lg-7",
                        style: slideInDownAnimate("0ms"),
                        children: /*#__PURE__*/ _jsx("figure", {
                            children: /*#__PURE__*/ _jsx("img", {
                                className: "w-auto",
                                src: "/img/illustrations/i6.png",
                                srcSet: "/img/illustrations/i6@2x.png 2x",
                                alt: ""
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero_Hero12 = ((/* unused pure expression or super */ null && (Hero12)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero13.tsx


// -------- custom hook -------- //

var Hero13 = function() {
    // use video popup
    useLightBox();
    return /*#__PURE__*/ _jsx("section", {
        style: {
            backgroundImage: "url(/img/photos/bg2.jpg)"
        },
        className: "wrapper image-wrapper bg-image bg-overlay bg-overlay-300 text-white",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pt-17 pb-19 pt-md-19 pb-md-20 text-center",
            children: /*#__PURE__*/ _jsx("div", {
                className: "row mb-11",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-md-9 col-lg-7 col-xxl-6 mx-auto",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "h6 text-uppercase ls-xl text-white mb-5",
                            style: zoomInAnimate("0ms"),
                            children: "Hello! This is SEOptimist"
                        }),
                        /*#__PURE__*/ _jsx("h3", {
                            className: "display-1 text-white mb-7",
                            style: zoomInAnimate("500ms"),
                            children: "We bring rapid solutions for your business"
                        }),
                        /*#__PURE__*/ _jsx("a", {
                            "data-glightbox": true,
                            href: "/media/movie.mp4",
                            className: "btn btn-circle btn-white btn-play ripple mx-auto mb-5",
                            style: zoomInAnimate("1000ms"),
                            children: /*#__PURE__*/ _jsx("i", {
                                className: "icn-caret-right"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var hero_Hero13 = ((/* unused pure expression or super */ null && (Hero13)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero14.tsx


var Hero14 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-soft-primary",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "container pt-10 pt-md-14 pb-14 pb-md-0",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-md-8 gx-lg-12 gy-3 gy-lg-0 mb-13",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-lg-6",
                            children: /*#__PURE__*/ _jsx("h1", {
                                className: "display-1 fs-66 lh-xxs mb-0",
                                children: "We bring rapid solutions for your business."
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-6",
                            children: [
                                /*#__PURE__*/ _jsx("p", {
                                    className: "lead fs-25 my-3",
                                    children: "We are an award winning branding design agency that strongly believes in the power of creative ideas."
                                }),
                                /*#__PURE__*/ _jsx(NextLink, {
                                    title: "Learn More",
                                    href: "#",
                                    className: "more hover"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "position-relative",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "shape bg-dot primary rellax w-17 h-21",
                            style: {
                                top: "-2.5rem",
                                right: "-2.7rem"
                            }
                        }),
                        /*#__PURE__*/ _jsx("figure", {
                            className: "rounded mb-md-n20",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "/img/photos/about18.jpg",
                                srcSet: "/img/photos/about18@2x.jpg 2x",
                                alt: ""
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var hero_Hero14 = ((/* unused pure expression or super */ null && (Hero14)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero15.tsx


// -------- custom hook -------- //


var Hero15 = function() {
    // use video popup
    useLightBox();
    return /*#__PURE__*/ _jsx("div", {
        className: "wrapper bg-dark",
        children: /*#__PURE__*/ _jsxs(Carousel, {
            slidesPerView: 1,
            className: "swiper-hero dots-over",
            autoplay: {
                delay: 7000,
                disableOnInteraction: false
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "swiper-slide bg-overlay bg-overlay-400 bg-dark bg-image",
                    style: {
                        backgroundImage: 'url("/img/photos/bg7.jpg")'
                    },
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "container h-100",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row h-100",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "col-md-10 offset-md-1 col-lg-7 offset-lg-0 col-xl-6 col-xxl-5 text-center text-lg-start justify-content-center align-self-center align-items-start",
                                children: [
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "display-1 fs-56 mb-4 text-white animate__animated animate__slideInDown animate__delay-1s",
                                        children: "We bring solutions to make life easier."
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "lead fs-23 lh-sm mb-7 text-white animate__animated animate__slideInRight animate__delay-2s",
                                        children: "We are a creative company that focuses on long term relationships with customers."
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "animate__animated animate__slideInUp animate__delay-3s",
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Read More",
                                            href: "#",
                                            className: "btn btn-lg btn-outline-white rounded-pill"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "swiper-slide bg-overlay bg-overlay-400 bg-dark bg-image",
                    style: {
                        backgroundImage: 'url("/img/photos/bg8.jpg")'
                    },
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "container h-100",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row h-100",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "col-md-11 col-lg-8 col-xl-7 col-xxl-6 mx-auto text-center justify-content-center align-self-center",
                                children: [
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "display-1 fs-56 mb-4 text-white animate__animated animate__slideInDown animate__delay-1s",
                                        children: "We are trusted by over a million customers."
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "lead fs-23 lh-sm mb-7 text-white animate__animated animate__slideInRight animate__delay-2s",
                                        children: "Here a few reasons why our customers choose us."
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "animate__animated animate__slideInUp animate__delay-3s",
                                        children: /*#__PURE__*/ _jsx("a", {
                                            "data-glightbox": true,
                                            href: "/media/movie.mp4",
                                            className: "btn btn-circle btn-white btn-play ripple mx-auto mb-5",
                                            children: /*#__PURE__*/ _jsx("i", {
                                                className: "icn-caret-right"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "swiper-slide bg-overlay bg-overlay-400 bg-dark bg-image",
                    style: {
                        backgroundImage: 'url("/img/photos/bg9.jpg")'
                    },
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "container h-100",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row h-100",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "col-md-10 offset-md-1 col-lg-7 offset-lg-5 col-xl-6 offset-xl-6 col-xxl-5 offset-xxl-6 text-center text-lg-start justify-content-center align-self-center align-items-start",
                                children: [
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "display-1 fs-56 mb-4 text-white animate__animated animate__slideInDown animate__delay-1s",
                                        children: "Just sit and relax."
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "lead fs-23 lh-sm mb-7 text-white animate__animated animate__slideInRight animate__delay-2s",
                                        children: "We make sure your spending is stress free so that you can have the perfect control."
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "animate__animated animate__slideInUp animate__delay-3s",
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Contact Us",
                                            href: "#",
                                            className: "btn btn-lg btn-outline-white rounded-pill"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_Hero15 = ((/* unused pure expression or super */ null && (Hero15)));

// EXTERNAL MODULE: ./src/icons/lineal/Check.tsx
var lineal_Check = __webpack_require__(9);
;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero16.tsx




// -------- custom component -------- //


var Hero16 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-gray",
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pt-12 pt-md-14 pb-14 pb-md-16",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "row gy-10 gy-md-13 gy-lg-0 align-items-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-md-8 col-lg-5 d-flex position-relative mx-auto",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "img-mask mask-1",
                                style: slideInDownAnimate("0ms"),
                                children: /*#__PURE__*/ _jsx("img", {
                                    src: "/img/photos/about17.jpg",
                                    srcSet: "/img/photos/about17@2x.jpg 2x",
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card shadow-lg position-absolute",
                                style: _object_spread({
                                    right: "2%",
                                    bottom: "10%"
                                }, slideInDownAnimate("300ms")),
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card-body py-4 px-5",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex flex-row align-items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                children: /*#__PURE__*/ _jsx(Check, {
                                                    className: "icon-svg-sm text-primary mx-auto me-3"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                children: [
                                                    /*#__PURE__*/ _jsx("h3", {
                                                        className: "counter mb-0 text-nowrap",
                                                        children: /*#__PURE__*/ _jsx(CountUp, {
                                                            end: 250,
                                                            suffix: "+"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("p", {
                                                        className: "fs-14 lh-sm mb-0 text-nowrap",
                                                        children: "Projects Done"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-6 offset-lg-1 col-xxl-5 text-center text-lg-start",
                        children: [
                            /*#__PURE__*/ _jsx("h1", {
                                className: "display-1 mb-5",
                                style: slideInDownAnimate("600ms"),
                                children: "I'm User Interface Designer & Developer."
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-25 lh-sm mb-7 px-md-10 px-lg-0",
                                style: slideInDownAnimate("900ms"),
                                children: "Hello! I'm Julia, a freelance user interface designer & developer based in London. I’m very passionate about the work that I do."
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex justify-content-center justify-content-lg-start",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1200ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "See My Works",
                                            href: "#",
                                            className: "btn btn-lg btn-primary rounded-pill me-2"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1500ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Contact Me",
                                            href: "#",
                                            className: "btn btn-lg btn-outline-primary rounded-pill"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero_Hero16 = ((/* unused pure expression or super */ null && (Hero16)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero17.tsx



var Hero17 = function() {
    return /*#__PURE__*/ _jsxs("section", {
        className: "wrapper bg-gray",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "container pt-12 pt-md-16 text-center",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-8 col-xxl-7 mx-auto text-center",
                        children: [
                            /*#__PURE__*/ _jsx("h2", {
                                className: "fs-16 text-uppercase ls-xl text-dark mb-4",
                                style: slideInDownAnimate("600ms"),
                                children: "Hello! This is SEOptimist"
                            }),
                            /*#__PURE__*/ _jsx("h1", {
                                className: "display-1 fs-58 mb-7",
                                style: slideInDownAnimate("900ms"),
                                children: "We bring rapid solutions for your business."
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "d-flex justify-content-center mb-5 mb-md-0",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1200ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Explore Now",
                                            href: "#",
                                            className: "btn btn-lg btn-primary rounded-pill me-2"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        style: slideInDownAnimate("1500ms"),
                                        children: /*#__PURE__*/ _jsx(NextLink, {
                                            title: "Contact Us",
                                            href: "#",
                                            className: "btn btn-lg btn-outline-primary rounded-pill"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("figure", {
                className: "position-absoute",
                style: {
                    bottom: 0,
                    left: 0,
                    zIndex: 2
                },
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/img/photos/bg11.jpg",
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var hero_Hero17 = ((/* unused pure expression or super */ null && (Hero17)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero18.tsx



var Hero18 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-light",
        children: /*#__PURE__*/ _jsx("div", {
            className: "image-wrapper bg-full bg-image bg-overlay bg-overlay-light-500 mt-2 mb-5",
            style: {
                backgroundImage: "url(/img/photos/bg22.png)"
            },
            children: /*#__PURE__*/ _jsx("div", {
                className: "container-card",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card border-0 bg-transparent",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "card-body py-14 px-0",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "container",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "row gx-md-8 gx-xl-12 gy-10 align-items-center text-center text-lg-start",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "col-lg-6",
                                        children: [
                                            /*#__PURE__*/ _jsxs("h1", {
                                                className: "display-2 mb-4 me-xl-5 me-xxl-0",
                                                style: slideInDownAnimate("900ms"),
                                                children: [
                                                    "Test your ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-gradient gradient-1",
                                                        children: "homepage"
                                                    }),
                                                    " for free."
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "lead fs-23 lh-sm mb-7 pe-xxl-15",
                                                style: slideInDownAnimate("1200ms")
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                style: slideInDownAnimate("1500ms"),
                                                children: /*#__PURE__*/ _jsx(NextLink, {
                                                    title: "Explore Now",
                                                    href: "#",
                                                    className: "btn btn-lg btn-gradient gradient-1 rounded"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-lg-6",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            alt: "demo",
                                            className: "img-fluid mb-n18",
                                            src: "/img/illustrations/3d6.png",
                                            srcSet: "/img/illustrations/3d6@2x.png 2x",
                                            style: fadeInAnimate("300ms")
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var hero_Hero18 = ((/* unused pure expression or super */ null && (Hero18)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero19.tsx


var Hero19 = function() {
    return /*#__PURE__*/ _jsxs("section", {
        className: "wrapper image-wrapper bg-image bg-overlay bg-overlay-300",
        style: {
            backgroundImage: "url(/img/photos/bg16.png)"
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "container pt-17 pb-19 pt-md-18 pb-md-17 text-center",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "col-lg-8 col-xl-7 col-xxl-6 mx-auto",
                        children: [
                            /*#__PURE__*/ _jsxs("h1", {
                                className: "display-1 text-white fs-60 mb-4 px-md-15 px-lg-0",
                                style: slideInDownAnimate("0ms"),
                                children: [
                                    "We bring solutions to make life ",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "underline-3 style-2 yellow",
                                        children: "easier"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "lead fs-24 text-white lh-sm mb-7 mx-md-13 mx-lg-10",
                                style: slideInDownAnimate("300ms"),
                                children: "We are a creative company that focuses on long term relationships with customers."
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                style: slideInDownAnimate("600ms"),
                                children: /*#__PURE__*/ _jsx("button", {
                                    className: "btn btn-white rounded mb-10 mb-xxl-5",
                                    children: "Read More"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "overflow-hidden",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "divider text-light mx-n2",
                    children: /*#__PURE__*/ _jsx("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 1440 60",
                        children: /*#__PURE__*/ _jsx("path", {
                            fill: "currentColor",
                            d: "M0,0V60H1440V0A5771,5771,0,0,1,0,0Z"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var hero_Hero19 = ((/* unused pure expression or super */ null && (Hero19)));

// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/hooks/useReplaceMe.ts



var useReplaceMe_useReplaceMe = function() {
    useEffect(function() {
        var replace;
        var options = {
            speed: 2500,
            separator: ",",
            clickChange: false,
            loopCount: "infinite"
        };
        (function() {
            var ReplaceMe = __webpack_require__(6238);
            if (document.querySelector(".rotator-zoom") !== null) {
                replace = new ReplaceMe(document.querySelector(".rotator-zoom"), _object_spread_props(_object_spread({}, options), {
                    animation: "animate__animated animate__zoomIn"
                }));
            }
            if (document.querySelector(".rotator-fade") !== null) {
                replace = new ReplaceMe(document.querySelector(".rotator-fade"), _object_spread_props(_object_spread({}, options), {
                    animation: "animate__animated animate__fadeInDown"
                }));
            }
        })();
        return function() {
            return replace === null || replace === void 0 ? void 0 : replace.stop();
        };
    }, []);
    return;
};
/* harmony default export */ var hooks_useReplaceMe = ((/* unused pure expression or super */ null && (useReplaceMe_useReplaceMe)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero20.tsx


var Hero20 = function() {
    // enable the text rotator animation
    useReplaceMe();
    return /*#__PURE__*/ _jsxs("section", {
        className: "video-wrapper bg-overlay bg-overlay-gradient px-0 mt-0 min-vh-80",
        children: [
            /*#__PURE__*/ _jsx("video", {
                loop: true,
                muted: true,
                autoPlay: true,
                playsInline: true,
                // __idm_id__="1187841"
                id: "1187841",
                src: "/media/movie2.mp4",
                poster: "/img/photos/movie2.jpg"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "video-content",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "container text-center",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-8 col-xl-6 text-center text-white mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("h1", {
                                    className: "display-1 fs-54 text-white mb-5",
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "rotator-zoom",
                                        children: "Rapid Solutions,Innovative Thinking,Top-Notch Support"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "lead fs-24 mb-0 mx-xxl-8",
                                    children: "We are a digital agency specializing in web design, mobile development and seo optimization."
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var hero_Hero20 = ((/* unused pure expression or super */ null && (Hero20)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero21.tsx


// -------- data -------- //

var Hero21 = function() {
    // enable the text rotator animation
    useReplaceMe();
    return /*#__PURE__*/ _jsxs("section", {
        className: "wrapper bg-light",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "container pt-10 pt-md-14 pb-14 pb-md-16 text-center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "row gx-lg-8 gx-xl-12 gy-10 gy-xl-0 mb-14 align-items-center",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-lg-7 order-lg-2",
                                children: /*#__PURE__*/ _jsx("figure", {
                                    children: /*#__PURE__*/ _jsx("img", {
                                        alt: "demo",
                                        className: "img-auto",
                                        src: "/img/illustrations/i21.png",
                                        srcSet: "/img/illustrations/i21@2x.png 2x"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "col-md-10 offset-md-1 offset-lg-0 col-lg-5 text-center text-lg-start",
                                children: [
                                    /*#__PURE__*/ _jsxs("h1", {
                                        className: "display-1 fs-54 mb-5 mx-md-n5 mx-lg-0 mt-7",
                                        children: [
                                            "A digital agency ",
                                            /*#__PURE__*/ _jsx("br", {
                                                className: "d-md-none"
                                            }),
                                            "specializing on ",
                                            /*#__PURE__*/ _jsx("br", {
                                                className: "d-md-none"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "rotator-fade text-primary",
                                                children: "mobile design,web design,3D animation"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "lead fs-lg mb-7",
                                        children: "We are an award winning design agency that strongly believes in the power of creative ideas."
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: /*#__PURE__*/ _jsx("a", {
                                            className: "btn btn-lg btn-primary rounded-pill me-2",
                                            children: "Get Started"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-center mb-8",
                        children: "Trusted by over 2K+ clients across the world"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "row row-cols-4 row-cols-md-4 row-cols-lg-7 row-cols-xl-7 gy-10 mb-2 d-flex align-items-center justify-content-center",
                        children: clientList.map(function(item) {
                            return /*#__PURE__*/ _jsx("div", {
                                className: "col",
                                children: /*#__PURE__*/ _jsx("img", {
                                    className: "img-fluid px-md-3 px-lg-0 px-xl-2 px-xxl-5",
                                    src: item,
                                    alt: "client"
                                })
                            }, item);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "overflow-hidden",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "divider text-soft-primary mx-n2",
                    children: /*#__PURE__*/ _jsx("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 1440 100",
                        children: /*#__PURE__*/ _jsx("path", {
                            fill: "currentColor",
                            d: "M1260,1.65c-60-5.07-119.82,2.47-179.83,10.13s-120,11.48-180,9.57-120-7.66-180-6.42c-60,1.63-120,11.21-180,16a1129.52,1129.52,0,0,1-180,0c-60-4.78-120-14.36-180-19.14S60,7,30,7H0v93H1440V30.89C1380.07,23.2,1319.93,6.15,1260,1.65Z"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var hero_Hero21 = ((/* unused pure expression or super */ null && (Hero21)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero22.tsx


var Hero22 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "section-frame br-fix overflow-hidden",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "wrapper image-wrapper bg-cover bg-image bg-overlay bg-overlay-500",
            style: {
                backgroundImage: "url(/img/photos/bg26.jpg)"
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "container pt-18 pt-lg-21 pb-17 pb-lg-19 text-center",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "col-md-9 col-lg-8 col-xl-7 col-xxl-6 mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "h6 text-uppercase ls-xl text-white mb-5",
                                    style: zoomInAnimate("500ms"),
                                    children: "Hello! We are SEOptimist"
                                }),
                                /*#__PURE__*/ _jsx("h3", {
                                    className: "display-1 fs-54 text-white mb-7",
                                    style: zoomInAnimate("1000ms"),
                                    children: "Grow your business with our marketing solutions"
                                }),
                                /*#__PURE__*/ _jsx("a", {
                                    "data-glightbox": true,
                                    href: "/media/movie.mp4",
                                    className: "btn btn-circle btn-white btn-play ripple mx-auto",
                                    style: zoomInAnimate("1500ms"),
                                    children: /*#__PURE__*/ _jsx("i", {
                                        className: "icn-caret-right"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "overflow-hidden",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "divider text-white mx-n2",
                        children: /*#__PURE__*/ _jsx("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 1440 60",
                            children: /*#__PURE__*/ _jsx("path", {
                                fill: "currentColor",
                                d: "M0,0V60H1440V0A5771,5771,0,0,1,0,0Z"
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_Hero22 = ((/* unused pure expression or super */ null && (Hero22)));

// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(6523);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(2546);
;// CONCATENATED MODULE: ./src/components/reuseable/Carousel2.tsx




var Carousel2_Carousel2 = function() {
    var ref = useState(), thumbsSwiper = ref[0], setThumbsSwiper = ref[1];
    var ref1 = useState(null), prevEl = ref1[0], setPrevEl = ref1[1];
    var ref2 = useState(null), nextEl = ref2[0], setNextEl = ref2[1];
    var slideImages = [
        {
            id: 1,
            url: "/img/photos/bg28.jpg"
        },
        {
            id: 2,
            url: "/img/photos/bg29.jpg"
        },
        {
            id: 3,
            url: "/img/photos/bg30.jpg"
        },
        {
            id: 4,
            url: "/img/photos/bg31.jpg"
        }
    ];
    var thumbImages = [
        {
            id: 1,
            url: "/img/photos/bg28-th.jpg"
        },
        {
            id: 2,
            url: "/img/photos/bg29-th.jpg"
        },
        {
            id: 3,
            url: "/img/photos/bg30-th.jpg"
        },
        {
            id: 4,
            url: "/img/photos/bg31-th.jpg"
        }
    ];
    return /*#__PURE__*/ _jsxs(Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "swiper-main",
                children: /*#__PURE__*/ _jsxs(SwiperCarousel, {
                    spaceBetween: 10,
                    pagination: false,
                    navigation: {
                        prevEl: prevEl,
                        nextEl: nextEl
                    },
                    modules: [
                        FreeMode,
                        Navigation,
                        Thumbs
                    ],
                    thumbs: {
                        swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
                    },
                    children: [
                        slideImages.map(function(param) {
                            var url = param.url, id = param.id;
                            return /*#__PURE__*/ _jsx(SwiperSlide, {
                                style: {
                                    backgroundImage: "url(".concat(url, ")")
                                },
                                className: "bg-overlay bg-overlay-400 bg-dark bg-image"
                            }, id);
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "swiper-navigation",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    role: "button",
                                    ref: function(node) {
                                        return setPrevEl(node);
                                    },
                                    className: "swiper-button swiper-button-prev swiper-button-disabled"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    role: "button",
                                    ref: function(node) {
                                        return setNextEl(node);
                                    },
                                    className: "swiper-button swiper-button-next"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(SwiperCarousel, {
                freeMode: true,
                threshold: 2,
                spaceBetween: 10,
                slidesPerView: 5,
                watchSlidesProgress: true,
                onSwiper: setThumbsSwiper,
                modules: [
                    FreeMode,
                    Navigation,
                    Thumbs
                ],
                children: thumbImages.map(function(param) {
                    var url = param.url, id = param.id;
                    return /*#__PURE__*/ _jsx(SwiperSlide, {
                        children: /*#__PURE__*/ _jsx("img", {
                            src: url,
                            alt: "product"
                        })
                    }, id);
                })
            })
        ]
    });
};
/* harmony default export */ var reuseable_Carousel2 = ((/* unused pure expression or super */ null && (Carousel2_Carousel2)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero23.tsx


var Hero23 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper bg-dark",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "swiper-container swiper-thumbs-container swiper-fullscreen nav-dark",
            children: [
                /*#__PURE__*/ _jsx(Carousel2, {}),
                /*#__PURE__*/ _jsx("div", {
                    className: "swiper-static",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "container h-100 d-flex align-items-center justify-content-center",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "row",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "col-lg-8 mx-auto mt-n10 text-center",
                                children: [
                                    /*#__PURE__*/ _jsx("h1", {
                                        className: "fs-19 text-uppercase ls-xl text-white mb-3 animate__animated animate__zoomIn animate__delay-1s",
                                        children: "I'm Julia SEOptimist"
                                    }),
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "display-1 fs-60 text-white mb-0 animate__animated animate__zoomIn animate__delay-2s",
                                        children: "couples & wedding photographer"
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_Hero23 = ((/* unused pure expression or super */ null && (Hero23)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero24.tsx


// -------- data -------- //
var Hero24_images = (/* unused pure expression or super */ null && ([
    "/img/photos/cf1.jpg",
    "/img/photos/cf2.jpg",
    "/img/photos/cf3.jpg",
    "/img/photos/cf4.jpg",
    "/img/photos/cf5.jpg",
    "/img/photos/cf6.jpg"
]));
var Hero24 = function() {
    return /*#__PURE__*/ _jsx("section", {
        id: "home",
        children: /*#__PURE__*/ _jsx("div", {
            className: "wrapper bg-gray overflow-hidden",
            children: /*#__PURE__*/ _jsx("div", {
                className: "container-fluid px-xl-0 pt-6 pb-10",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "swiper-container swiper-auto",
                    children: /*#__PURE__*/ _jsx(Carousel, {
                        className: "overflow-visible",
                        grabCursor: true,
                        slidesPerView: "auto",
                        centeredSlides: true,
                        loop: true,
                        children: Hero24_images.map(function(item) {
                            return /*#__PURE__*/ _jsxs("figure", {
                                className: "rounded",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: item,
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ _jsx("a", {
                                        className: "item-link",
                                        href: item,
                                        "data-glightbox": true,
                                        "data-gallery": "gallery-group",
                                        children: /*#__PURE__*/ _jsx("i", {
                                            className: "uil uil-focus-add"
                                        })
                                    })
                                ]
                            }, item);
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var hero_Hero24 = ((/* unused pure expression or super */ null && (Hero24)));

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
;// CONCATENATED MODULE: ./src/components/reuseable/blog-cards/BlogCard1.tsx




// ======================================================
var BlogCard1 = function(param) {
    var date = param.date, image = param.image, title = param.title, category = param.category;
    return /*#__PURE__*/ _jsxs("article", {
        children: [
            /*#__PURE__*/ _jsxs("figure", {
                className: "overlay overlay-1 hover-scale rounded mb-6",
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        // legacyBehavior2 passHref2 
                        href: "#",
                        children: /*#__PURE__*/ _jsxs("a", {
                            children: [
                                /*#__PURE__*/ _jsx(Image, {
                                    width: 560,
                                    height: 350,
                                    src: image,
                                    alt: title,
                                    layout: "responsive"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "bg"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("figcaption", {
                        children: /*#__PURE__*/ _jsx("h5", {
                            className: "from-top mb-0",
                            children: "Read More"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "post-header",
                children: /*#__PURE__*/ _jsx("h2", {
                    className: "post-title h3 mb-3",
                    children: /*#__PURE__*/ _jsx(NextLink, {
                        title: "Ligula tristique quis risus",
                        className: "link-dark",
                        href: "#"
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "post-footer",
                children: /*#__PURE__*/ _jsxs("ul", {
                    className: "post-meta",
                    children: [
                        /*#__PURE__*/ _jsxs("li", {
                            className: "post-date",
                            children: [
                                /*#__PURE__*/ _jsx("i", {
                                    className: "uil uil-calendar-alt"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: date
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("li", {
                            className: "post-comments",
                            children: /*#__PURE__*/ _jsx(NextLink, {
                                href: "#",
                                className: "link-dark",
                                title: /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        /*#__PURE__*/ _jsx("i", {
                                            className: "uil uil-file-alt fs-15"
                                        }),
                                        category
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var blog_cards_BlogCard1 = ((/* unused pure expression or super */ null && (BlogCard1)));

;// CONCATENATED MODULE: ./src/components/reuseable/blog-cards/BlogCard2.tsx



// ========================================================
var BlogCard2 = function(props) {
    var cardTop = props.cardTop, title = props.title, category = props.category, description = props.description, link = props.link;
    return /*#__PURE__*/ _jsx("article", {
        className: "post",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card",
            children: [
                cardTop,
                /*#__PURE__*/ _jsxs("div", {
                    className: "card-body",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "post-header",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "post-category text-line",
                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                        title: category,
                                        href: "#",
                                        className: "hover"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "post-title mt-1 mb-0",
                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                        title: title,
                                        className: "link-dark",
                                        href: link
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "post-content",
                            children: /*#__PURE__*/ _jsx("p", {
                                children: description
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "card-footer",
                    children: /*#__PURE__*/ _jsxs("ul", {
                        className: "post-meta d-flex mb-0",
                        children: [
                            /*#__PURE__*/ _jsxs("li", {
                                className: "post-date",
                                children: [
                                    /*#__PURE__*/ _jsx("i", {
                                        className: "uil uil-calendar-alt"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "5 Jul 2022"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "post-author",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    // legacyBehavior2 passHref2 
                                    href: "#",
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        children: [
                                            /*#__PURE__*/ _jsx("i", {
                                                className: "uil uil-user"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "By SEOptimist "
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "post-comments",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    // legacyBehavior2 passHref2 
                                    href: "#",
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        children: [
                                            /*#__PURE__*/ _jsx("i", {
                                                className: "uil uil-comment"
                                            }),
                                            " 3",
                                            /*#__PURE__*/ _jsx("span", {
                                                children: " Comments"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "post-likes ms-auto",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    // legacyBehavior2 passHref2 
                                    href: "#",
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        children: [
                                            /*#__PURE__*/ _jsx("i", {
                                                className: "uil uil-heart-alt"
                                            }),
                                            "3"
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var blog_cards_BlogCard2 = ((/* unused pure expression or super */ null && (BlogCard2)));

// EXTERNAL MODULE: ./src/components/reuseable/FigureImage.tsx
var reuseable_FigureImage = __webpack_require__(2744);
;// CONCATENATED MODULE: ./src/components/reuseable/blog-cards/BlogCard3.tsx




// ========================================================
var BlogCard3 = function(props) {
    var title = props.title, category = props.category, description = props.description, link = props.link, image = props.image;
    return /*#__PURE__*/ _jsx("article", {
        className: "item post col-md-6",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card",
            children: [
                /*#__PURE__*/ _jsxs("figure", {
                    className: "card-img-top overlay overlay-1 hover-scale",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            // legacyBehavior2 passHref2 
                            href: "#",
                            children: /*#__PURE__*/ _jsxs("a", {
                                children: [
                                    /*#__PURE__*/ _jsx(FigureImage, {
                                        width: 560,
                                        height: 350,
                                        src: image
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "bg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("figcaption", {
                            children: /*#__PURE__*/ _jsx("h5", {
                                className: "from-top mb-0",
                                children: "Read More"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "card-body",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "post-header",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "post-category text-line",
                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                        title: category,
                                        href: "#",
                                        className: "hover"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("h2", {
                                    className: "post-title h3 mt-1 mb-3",
                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                        title: title,
                                        className: "link-dark",
                                        href: link
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "post-content",
                            children: /*#__PURE__*/ _jsx("p", {
                                children: description
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "card-footer",
                    children: /*#__PURE__*/ _jsxs("ul", {
                        className: "post-meta d-flex mb-0",
                        children: [
                            /*#__PURE__*/ _jsxs("li", {
                                className: "post-date",
                                children: [
                                    /*#__PURE__*/ _jsx("i", {
                                        className: "uil uil-calendar-alt"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: "14 Apr 2022"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "post-comments",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    // legacyBehavior2 passHref2 
                                    href: "#",
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        children: [
                                            /*#__PURE__*/ _jsx("i", {
                                                className: "uil uil-comment"
                                            }),
                                            "4"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "post-likes ms-auto",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    // legacyBehavior2 passHref2 
                                    href: "#",
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        children: [
                                            /*#__PURE__*/ _jsx("i", {
                                                className: "uil uil-heart-alt"
                                            }),
                                            "5"
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var blog_cards_BlogCard3 = ((/* unused pure expression or super */ null && (BlogCard3)));

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
;// CONCATENATED MODULE: ./src/components/reuseable/blog-cards/BlogCard4.tsx





// ======================================================
var BlogCard4 = function(props) {
    var date = props.date, image = props.image, title = props.title, category = props.category, description = props.description;
    return /*#__PURE__*/ _jsx("article", {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "card",
            children: [
                /*#__PURE__*/ _jsxs("figure", {
                    className: "card-img-top overlay overlay-1 hover-scale",
                    children: [
                        /*#__PURE__*/ _jsx(Link, {
                            // legacyBehavior2 passHref2 
                            href: "#",
                            children: /*#__PURE__*/ _jsxs("a", {
                                children: [
                                    /*#__PURE__*/ _jsx(Image, {
                                        width: 560,
                                        height: 350,
                                        src: image,
                                        alt: title,
                                        layout: "responsive"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "bg"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("figcaption", {
                            children: /*#__PURE__*/ _jsx("h5", {
                                className: "from-top mb-0",
                                children: "Read More"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "card-body",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "post-header",
                            children: /*#__PURE__*/ _jsx("h2", {
                                className: "post-title h3 mt-1 mb-3",
                                children: /*#__PURE__*/ _jsx(NextLink, {
                                    title: title,
                                    className: "link-dark",
                                    href: "#"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "post-content",
                            children: /*#__PURE__*/ _jsx("p", {
                                children: description
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "card-footer",
                    children: /*#__PURE__*/ _jsxs("ul", {
                        className: "post-meta d-flex mb-0",
                        children: [
                            /*#__PURE__*/ _jsxs("li", {
                                className: "post-date",
                                children: [
                                    /*#__PURE__*/ _jsx("i", {
                                        className: "uil uil-calendar-alt"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: dayjs(date).format("DD MMM YYYY")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "post-comments",
                                children: /*#__PURE__*/ _jsx(NextLink, {
                                    href: "#",
                                    className: "link-dark",
                                    title: /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("i", {
                                                className: "uil uil-file-alt fs-15"
                                            }),
                                            category
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var blog_cards_BlogCard4 = ((/* unused pure expression or super */ null && (BlogCard4)));

;// CONCATENATED MODULE: ./src/components/reuseable/blog-cards/BlogCard5.tsx




// ======================================================
var BlogCard5_BlogCard5 = function(props) {
    var image = props.image, title = props.title, author = props.author, category = props.category, createdAt = props.createdAt, comments = props.comments;
    return /*#__PURE__*/ _jsxs("figure", {
        className: "overlay caption caption-overlay rounded mb-0",
        children: [
            /*#__PURE__*/ _jsx(Link, {
                // legacyBehavior2 passHref2 
                href: "#",
                children: /*#__PURE__*/ _jsxs("a", {
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: image,
                            alt: ""
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "bg"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("figcaption", {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "badge badge-lg bg-white text-uppercase mb-3",
                        children: category
                    }),
                    /*#__PURE__*/ _jsx("h2", {
                        className: "post-title h3 mt-1 mb-3",
                        children: /*#__PURE__*/ _jsx(NextLink, {
                            title: title,
                            href: "#"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("ul", {
                        className: "post-meta text-white mb-0",
                        children: [
                            /*#__PURE__*/ _jsxs("li", {
                                className: "post-date",
                                children: [
                                    /*#__PURE__*/ _jsx("i", {
                                        className: "uil uil-calendar-alt"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: dayjs(createdAt).format("DD MMM YYYY")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "post-author",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    // legacyBehavior2 passHref2 
                                    href: "#",
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        children: [
                                            /*#__PURE__*/ _jsx("i", {
                                                className: "uil uil-user"
                                            }),
                                            /*#__PURE__*/ _jsxs("span", {
                                                children: [
                                                    "By ",
                                                    author
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("li", {
                                className: "post-comments",
                                children: /*#__PURE__*/ _jsx(Link, {
                                    // legacyBehavior2 passHref2 
                                    href: "#",
                                    children: /*#__PURE__*/ _jsxs("a", {
                                        children: [
                                            /*#__PURE__*/ _jsx("i", {
                                                className: "uil uil-comment"
                                            }),
                                            comments,
                                            " ",
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "Comments"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog_cards_BlogCard5 = ((/* unused pure expression or super */ null && (BlogCard5_BlogCard5)));

;// CONCATENATED MODULE: ./src/components/reuseable/blog-cards/index.ts







;// CONCATENATED MODULE: ./src/data/blog.ts
// used in the blog-1 block
var blogList1 = [
    {
        id: 1,
        category: "Coding",
        date: "14 Apr 2022",
        image: "/img/photos/b4.jpg",
        title: "Ligula tristique quis risus"
    },
    {
        id: 2,
        category: "Workspace",
        date: "29 Mar 2022",
        image: "/img/photos/b5.jpg",
        title: "ullam id dolor elit id nibh"
    },
    {
        id: 3,
        category: "Meeting",
        date: "26 Feb 2022",
        image: "/img/photos/b6.jpg",
        title: "Ultricies fusce porta elit"
    },
    {
        id: 4,
        category: "Business Tips",
        date: "7 Jan 2022",
        image: "/img/photos/b7.jpg",
        title: "Morbi leo risus porta eget"
    }
];
// used in the blog-3, blog-4 block
var blogList2 = [
    {
        id: 1,
        category: "Coding",
        date: "14 Apr 2022",
        image: "/img/photos/b4.jpg",
        title: "Ligula tristique quis risus"
    },
    {
        id: 2,
        category: "Workspace",
        date: "29 Mar 2022",
        image: "/img/photos/b5.jpg",
        title: "ullam id dolor elit id nibh"
    },
    {
        id: 3,
        category: "Meeting",
        date: "26 Feb 2022",
        image: "/img/photos/b6.jpg",
        title: "Ultricies fusce porta elit"
    },
    {
        id: 4,
        category: "Business Tips",
        date: "7 Jan 2022",
        image: "/img/photos/b7.jpg",
        title: "Morbi leo risus porta eget"
    }
];
// used in the blog-5 block
var blogList3 = [
    {
        id: 1,
        link: "#",
        comments: 4,
        category: "Wedding",
        createdAt: "14 Apr 2022",
        title: "Ligula tristique quis risus",
        image: {
            "1x": "/img/photos/b12.jpg",
            "2x": "/img/photos/b12@2x.jpg 2x"
        }
    },
    {
        id: 2,
        link: "#",
        comments: 3,
        category: "Engagement",
        createdAt: "29 Mar 2022",
        title: "Ligula tristique quis risus",
        image: {
            "1x": "/img/photos/b13.jpg",
            "2x": "/img/photos/b13@2x.jpg 2x"
        }
    },
    {
        id: 3,
        link: "#",
        comments: 6,
        category: "Couples",
        createdAt: "26 Feb 2022",
        title: "Ultricies fusce porta elit",
        image: {
            "1x": "/img/photos/b14.jpg",
            "2x": "/img/photos/b14@2x.jpg 2x"
        }
    },
    {
        id: 4,
        link: "#",
        comments: 3,
        category: "Engagement",
        createdAt: "17 Jan 2022",
        title: "Morbi leo risus porta eget",
        image: {
            "1x": "/img/photos/b15.jpg",
            "2x": "/img/photos/b15@2x.jpg 2x"
        }
    },
    {
        id: 5,
        link: "#",
        comments: 1,
        category: "Couples",
        createdAt: "7 Jan 2022",
        title: "Nulla vitae elit libero",
        image: {
            "1x": "/img/photos/b16.jpg",
            "2x": "/img/photos/b16@2x.jpg 2x"
        }
    },
    {
        id: 6,
        link: "#",
        comments: 2,
        category: "Wedding",
        createdAt: "2 Jan 2022",
        title: "Pharetra augue elit sem",
        image: {
            "1x": "/img/photos/b17.jpg",
            "2x": "/img/photos/b17@2x.jpg 2x"
        }
    }
];
// used in the blog-6 block
var blogList4 = [
    {
        id: 1,
        link: "#",
        category: "Roadtrip",
        image: "/img/photos/tb10.jpg",
        title: "Ligula tristique quis risus",
        description: "Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor. Aenean lacinia bibendum nulla sed."
    },
    {
        id: 2,
        link: "#",
        category: "Historic",
        image: "/img/photos/tb11.jpg",
        title: "Nullam id dolor elit id nibh",
        description: "Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor. Aenean lacinia bibendum nulla sed."
    },
    {
        id: 3,
        link: "#",
        category: "Cities",
        image: "/img/photos/tb12.jpg",
        title: "Ultricies fusce porta elit",
        description: "Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor. Aenean lacinia bibendum nulla sed."
    },
    {
        id: 4,
        link: "#",
        category: "Beaches",
        image: "/img/photos/tb13.jpg",
        title: "Morbi leo risus porta eget",
        description: "Mauris convallis non ligula non interdum. Gravida vulputate convallis tempus vestibulum cras imperdiet nun eu dolor. Aenean lacinia bibendum nulla sed."
    }
];
// used in the hero-25 block
var blog_blogList5 = [
    {
        id: 1,
        comments: 3,
        author: "SEOptimist",
        category: "Places",
        createdAt: "8 Aug 2022",
        image: "/img/photos/tb1.jpg",
        title: "The Best Moments in Venice"
    },
    {
        id: 2,
        comments: 5,
        author: "SEOptimist",
        category: "Restaurants",
        createdAt: "5 Jul 2022",
        image: "/img/photos/tb2.jpg",
        title: "10 Great Places in Belgium"
    },
    {
        id: 3,
        comments: 8,
        author: "SEOptimist",
        category: "Roadtrip",
        createdAt: "23 Jun 2022",
        image: "/img/photos/tb3.jpg",
        title: "A Dreamy Roadtrip in Australia"
    },
    {
        id: 4,
        comments: 9,
        author: "SEOptimist",
        category: "Historic",
        createdAt: "15 Apr 2022",
        image: "/img/photos/tb4.jpg",
        title: "My Love Affair with Cappadocia"
    },
    {
        id: 5,
        comments: 11,
        author: "SEOptimist",
        category: "Nature",
        createdAt: "14 Feb 2022",
        image: "/img/photos/tb5.jpg",
        title: "24 Hours in a Village of Valencia"
    },
    {
        id: 6,
        comments: 8,
        author: "SEOptimist",
        category: "Architecture",
        createdAt: "22 Jan 2022",
        image: "/img/photos/tb6.jpg",
        title: "The Largest Train Station in Europe"
    },
    {
        id: 7,
        comments: 14,
        author: "SEOptimist",
        category: "Nature",
        createdAt: "2 Jan 2022",
        image: "/img/photos/tb7.jpg",
        title: "The Natural Places in Brazil"
    }
];

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero25.tsx




// -------- data -------- //

var Hero25 = function() {
    return /*#__PURE__*/ _jsx(Carousel, {
        navigation: false,
        slidesPerView: 2,
        className: "blog grid-view mb-11",
        breakpoints: {
            0: {
                slidesPerView: 1
            },
            992: {
                slidesPerView: 2
            }
        },
        children: blogList5.map(function(item) {
            return /*#__PURE__*/ _jsx(BlogCard5, _object_spread({}, item), item.id);
        })
    });
};
/* harmony default export */ var hero_Hero25 = ((/* unused pure expression or super */ null && (Hero25)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero26.tsx


var Hero26 = function() {
    return /*#__PURE__*/ _jsxs("section", {
        className: "wrapper bg-soft-primary",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "container pt-10 pt-lg-12 pt-xl-12 pt-xxl-10 pb-lg-10 pb-xl-10 pb-xxl-0",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-md-8 gx-xl-12 gy-10 align-items-center text-center text-lg-start",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "col-lg-6",
                            "data-cues": "slideInDown",
                            "data-group": "page-title",
                            "data-delay": "900",
                            children: [
                                /*#__PURE__*/ _jsxs("h1", {
                                    className: "display-1 mb-4 me-xl-5 mt-lg-n10",
                                    children: [
                                        "Grow Your Business with ",
                                        /*#__PURE__*/ _jsx("br", {
                                            className: "d-none d-md-block d-lg-none"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "text-primary",
                                            children: "Our Marketing Solutions"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: "lead fs-24 lh-sm mb-7 pe-xxl-15",
                                    children: [
                                        "We help our clients to increase their website ",
                                        /*#__PURE__*/ _jsx("br", {
                                            className: "d-none d-md-block d-lg-none"
                                        }),
                                        " traffic, rankings and visibility in search results."
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "d-inline-flex me-2",
                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                        href: "#",
                                        title: "Try it for Free",
                                        className: "btn btn-lg btn-grape rounded"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "d-inline-flex",
                                    children: /*#__PURE__*/ _jsx(NextLink, {
                                        href: "#",
                                        title: "Explore Now",
                                        className: "btn btn-lg btn-outline-grape rounded"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-10 col-md-7 mx-auto col-lg-6 col-xl-5 ms-xl-5",
                            children: /*#__PURE__*/ _jsx("img", {
                                className: "img-fluid mb-n12 mb-md-n14 mb-lg-n19",
                                src: "/img/illustrations/3d11.png",
                                srcSet: "/img/illustrations/3d11@2x.png 2x",
                                "data-cue": "fadeIn",
                                "data-delay": "300",
                                alt: ""
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("figure", {
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/img/photos/clouds.png",
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var hero_Hero26 = ((/* unused pure expression or super */ null && (Hero26)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/Hero27.tsx


var Hero27 = function() {
    return /*#__PURE__*/ _jsx("section", {
        className: "wrapper image-wrapper bg-cover bg-image bg-xs-none bg-gray",
        style: {
            backgroundImage: "url(/img/photos/bg37.jpg)"
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "container pt-17 pb-15 py-sm-17 py-xxl-20",
            children: /*#__PURE__*/ _jsx("div", {
                className: "row",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "col-sm-6 col-xxl-5 text-center text-sm-start",
                    "data-cues": "slideInDown",
                    "data-group": "page-title",
                    "data-interval": "-200",
                    "data-delay": "500",
                    children: [
                        /*#__PURE__*/ _jsxs("h2", {
                            className: "display-1 fs-56 mb-4 mt-0 mt-lg-5 ls-xs pe-xl-5 pe-xxl-0",
                            children: [
                                "We bring solutions to make life ",
                                /*#__PURE__*/ _jsx("span", {
                                    className: "underline-3 style-3 yellow",
                                    children: "easier"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "lead fs-23 lh-sm mb-7 pe-lg-5 pe-xl-5 pe-xxl-0",
                            children: "We are a creative company that focuses on long term relationships with customers."
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            children: /*#__PURE__*/ _jsx(NextLink, {
                                title: "Read More",
                                href: "#",
                                className: "btn btn-lg btn-primary rounded"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var hero_Hero27 = ((/* unused pure expression or super */ null && (Hero27)));

;// CONCATENATED MODULE: ./src/components/blocks/hero/index.ts


// import Hero2 from './Hero2';
// import Hero3 from './Hero3';



























/***/ }),

/***/ 2920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var components_common_GeoAudit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3099);


var Video = function(param) {
    var intro = param.intro, heading = param.heading, title1 = param.title1, title2 = param.title2, title3 = param.title3, movie = param.movie, body = param.body, placeholder = param.placeholder, button = param.button, fontsize1 = param.fontsize1, fontsize2 = param.fontsize2, auditHero = param.auditHero;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "py-15 video-hero wrapper angled lower-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex justify-content-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                        style: {
                            order: 1
                        },
                        className: "flex order-1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "hero_text",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "fs-".concat(fontsize1),
                                        style: {
                                            fontFamily: "avenir !important"
                                        },
                                        children: title1
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "fs-".concat(fontsize2),
                                        style: {
                                            fontFamily: "avenir !important"
                                        },
                                        children: title2
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                autoPlay: true,
                                loop: true,
                                playsInline: true,
                                muted: true,
                                poster: placeholder,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                    src: movie,
                                    type: "video/mp4"
                                })
                            })
                        ]
                    }),
                    !auditHero && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        style: {
                            order: 2,
                            textAlign: "center",
                            paddingTop: "5vh",
                            textTransform: "none"
                        },
                        className: "flex order-2 animate__animated animate__slideInUp animate__delay-1s",
                        children: heading
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-12 col-sm-12 col-lg-11 col-xl-10 mx-auto text-center mb-5",
                    children: [
                        !auditHero && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "animate__animated animate__slideInUp animate__delay-2s",
                            children: [
                                "SEOptimist  ",
                                intro
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-4",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_GeoAudit__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                takeover: true,
                                showHeading: auditHero
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Video);


/***/ }),

/***/ 3099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var GeoAudit = function(param) {
    var _takeover = param.takeover, takeover = _takeover === void 0 ? false : _takeover, _showHeading = param.showHeading, showHeading = _showHeading === void 0 ? false : _showHeading;
    var loaded = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (loaded.current) return;
        loaded.current = true;
        var s = document.createElement("script");
        s.src = "https://audit.seoptimist.co.uk/widget.js";
        s.async = true;
        document.body.appendChild(s);
    }, []);
    var baseAttrs = {
        "data-logo": "https://seoptimist.co.uk/seoptimist-black.png",
        "data-cta-email": "james@seoptimist.co.uk",
        "data-cta-url": "seoptimist.co.uk",
        "data-cta-text": "Get in touch to start appearing in AI answers",
        "data-email-capture": ""
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n        /* light theme - standalone /ai-visibility */\n        .geo-embed-wrap .geo-audit {\n          --geo-font: inherit; --geo-display: inherit;\n          --geo-bg:#ffffff; --geo-surface:#f7f9fc; --geo-surface-solid:#f7f9fc;\n          --geo-ink:#343f52; --geo-ink-soft:#6b7480; --geo-line:#e3e7ee;\n          --geo-accent:#3f78e0; --geo-accent-ink:#ffffff;\n          --geo-positive:#45c4a0; --geo-alert:#e0533f; --geo-highlight:#dbe6fb;\n          --geo-neutral:#c3c9d4; --geo-link:#3f78e0; --geo-radius:14px; --geo-btn-radius:10px;\n        }\n        .geo-embed-wrap { max-width:960px; margin-left:auto; margin-right:auto; }\n\n        /* dark theme - hero takeover (scoped to the element so it survives the portal-to-body) */\n        .geo-audit[data-mode=takeover] {\n          --geo-font: inherit; --geo-display: inherit;\n          --geo-bg:#101216; --geo-surface:#191c22; --geo-surface-solid:#191c22;\n          --geo-ink:#e6e9ee; --geo-ink-soft:#aab2bd; --geo-line:#2e333c;\n          --geo-accent:#3f78e0; --geo-accent-ink:#f4f6f9;\n          --geo-positive:#45c4a0; --geo-alert:#e0735f; --geo-highlight:rgba(63,120,224,.22);\n          --geo-neutral:#5b6470; --geo-link:#5eb9f0; --geo-radius:12px; --geo-btn-radius:8px;\n        }\n        /* D-017 brightness hierarchy (seoptimist dark, host-side only): headings brightest, body a step\n           down (both off-white, never pure white), secondary = --geo-ink-soft. */\n        .geo-audit[data-mode=takeover] h1,\n        .geo-audit[data-mode=takeover] h2,\n        .geo-audit[data-mode=takeover] h3,\n        .geo-audit[data-mode=takeover] h4 { color:#f4f6f9; }\n\n        /* SIZING: mirror the site's Bootstrap .form-control + .btn (field .75rem, padding .6rem 1rem) */\n        .geo-embed-wrap .geo-audit input, .geo-embed-wrap .geo-audit textarea, .geo-embed-wrap .geo-audit select,\n        .geo-audit[data-mode=takeover] input, .geo-audit[data-mode=takeover] textarea, .geo-audit[data-mode=takeover] select {\n          padding:.6rem 1rem; font-size:.75rem; line-height:1.7; border-radius:.4rem;\n        }\n        .geo-embed-wrap .geo-audit button, .geo-audit[data-mode=takeover] button {\n          padding:.5rem 1.2rem; font-size:.8rem; border-radius:.4rem;\n        }\n        .geo-embed-wrap .geo-audit label, .geo-audit[data-mode=takeover] label { font-size:.7rem; }\n\n        /* dark-only colours (widget reuses --geo-ink for button bg + translucent white for inputs) */\n        .geo-audit[data-mode=takeover] button { background:var(--geo-accent); }\n        .geo-audit[data-mode=takeover] button:hover:not(:disabled) { background:#5b8de8; }\n        .geo-audit[data-mode=takeover] input,\n        .geo-audit[data-mode=takeover] textarea,\n        .geo-audit[data-mode=takeover] select { background:rgba(255,255,255,.06); }\n\n        /* COMPACT HERO (takeover, before expand): no outer panel, no card bubble - just heading + bare field */\n        .geo-embed-dark .geo-audit[data-mode=takeover]:not(.geo-takeover-open) { background:transparent !important; border-radius:0; }\n        .geo-embed-dark .geo-audit[data-mode=takeover]:not(.geo-takeover-open)::before { display:none; }\n        .geo-embed-dark .geo-audit[data-mode=takeover]:not(.geo-takeover-open) .wrap { padding:0; }\n        .geo-embed-dark .geo-audit[data-mode=takeover]:not(.geo-takeover-open) .card[data-key=domain] {\n          background:transparent; border:none; box-shadow:none; padding:0; margin:1.4rem auto 0; max-width:500px;\n        }\n        .geo-embed-dark .geo-audit[data-mode=takeover]:not(.geo-takeover-open) .card[data-key=domain] label { display:none; }\n        /* show the widget's own heading/intro in the compact hero (replaces the site H1) */\n        .geo-audit.geo-hero-head[data-mode=takeover]:not(.geo-takeover-open) h1,\n        .geo-audit.geo-hero-head[data-mode=takeover]:not(.geo-takeover-open) .sub { display:block; text-align:center; }\n\n        /* DOMAIN FIELD: input grows, small Check button to the right; stack on mobile */\n        .geo-audit[data-mode=takeover] .card[data-key=domain] .row { display:flex; flex-wrap:nowrap; align-items:stretch; gap:10px; width:100%; max-width:100%; }\n        .geo-audit[data-mode=takeover] .card[data-key=domain] .row input { flex:1 1 0; width:auto; min-width:0; }\n        .geo-audit[data-mode=takeover] .card[data-key=domain] .row button { flex:0 0 auto; width:auto; white-space:nowrap; }\n        @media (max-width:560px){\n          .geo-audit[data-mode=takeover] .card[data-key=domain] .row { flex-direction:column; }\n          /* 2026-10-22: Bootstrap's .row has -15px side margins, which pushed the field 15px past the card and the card's overflow:hidden cut the left edge off. On phones the row now fills the card exactly, and the field and button are about a third smaller. */\n          .geo-audit[data-mode=takeover] .card[data-key=domain] .row { margin-left:0; margin-right:0; }\n          .geo-audit[data-mode=takeover] .card[data-key=domain] .row input { padding:.4rem .8rem; font-size:.7rem; line-height:1.5; }\n          .geo-audit[data-mode=takeover] .card[data-key=domain] .row button { padding:.45rem 1rem; font-size:.72rem; }\n          .geo-audit[data-mode=takeover] .card[data-key=domain] .row button { width:100%; }\n        }\n\n        .geo-embed-dark { max-width:700px; margin-left:auto; margin-right:auto; }\n\n        @media print {\n          .geo-embed-heading { display:none !important; }\n          .geo-embed-section { padding:0 !important; }\n          .geo-embed-wrap, .geo-embed-dark { max-width:none !important; margin:0 !important; }\n          .geo-audit[data-mode=takeover] {\n            --geo-bg:#ffffff; --geo-surface:#f7f9fc; --geo-surface-solid:#f7f9fc;\n            --geo-ink:#343f52; --geo-ink-soft:#6b7480; --geo-line:#e3e7ee; --geo-highlight:#dbe6fb;\n          }\n          .geo-audit[data-mode=takeover] button { background:var(--geo-ink); }\n          .geo-audit[data-mode=takeover] input { background:#fff; }\n        }\n      "
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: takeover ? "geo-embed-dark" : "geo-embed-wrap",
                children: takeover ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                    className: "geo-audit" + (showHeading ? " geo-hero-head" : ""),
                    "data-mode": "takeover",
                    "data-eyebrow": "",
                    "data-heading": "Are you in AI answers?"
                }, baseAttrs)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                    className: "geo-audit",
                    "data-scroll-offset": "100"
                }, baseAttrs))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GeoAudit);


/***/ }),

/***/ 6238:
/***/ (function(module) {


/*!
 *  replaceme.js - text rotating component in vanilla JavaScript
 *  @version 1.1.0
 *  @author Adrian Klimek
 *  @link https://adrianklimek.github.io/replaceme/
 *  @copyright Adrian Klimek 2016
 *  @license MIT
 */ var ReplaceMe = function() {
    "use strict";
    var extend = // Extend defaults
    function extend(target, values) {
        for(var P in values){
            if (values.hasOwnProperty(P)) {
                target[P] = values[P];
            }
        }
        return target;
    };
    var ReplaceMe = // Constructor
    function ReplaceMe(element, options) {
        // Defaults
        var defaults = {
            animation: "animated fadeIn",
            speed: 2000,
            separator: ",",
            hoverStop: false,
            clickChange: false,
            loopCount: "infinite",
            autoRun: true,
            onInit: false,
            onChange: false,
            onComplete: false // Function
        };
        // Extend defaults
        if (typeof options == "object") {
            this.options = extend(defaults, options);
        } else {
            this.options = defaults;
        }
        // Get element
        if (typeof element == "undefined") {
            throw new Error('ReplaceMe [constructor]: "element" parameter is required');
        } else if (typeof element == "object") {
            this.element = element;
        } else if (typeof element == "string") {
            this.element = document.querySelector(element);
        } else {
            throw new Error('ReplaceMe [constructor]: wrong "element" parameter');
        }
        this.init();
    };
    ReplaceMe.prototype.init = function() {
        if (typeof this.options.onInit == "function") {
            this.options.onInit();
        }
        this.words = this.escapeHTML(this.element.innerHTML).split(this.options.separator);
        this.count = this.words.length;
        this.position = this.loopCount = 0;
        this.running = false;
        this.bindAll();
        if (this.options.autoRun === true) {
            this.start();
        }
    };
    ReplaceMe.prototype.bindAll = function() {
        if (this.options.hoverStop === true) {
            this.element.addEventListener("mouseover", this.pause.bind(this));
            this.element.addEventListener("mouseout", this.start.bind(this));
        }
        if (this.options.clickChange === true) {
            this.element.addEventListener("click", this.change.bind(this));
        }
    };
    ReplaceMe.prototype.changeAnimation = function() {
        this.change();
        this.loop = setTimeout(this.changeAnimation.bind(this), this.options.speed);
    };
    ReplaceMe.prototype.start = function() {
        if (this.running !== true) {
            this.running = true;
            this.changeWord(this.words[this.position]);
            this.position++;
        }
        this.loop = setTimeout(this.changeAnimation.bind(this), this.options.speed);
    };
    ReplaceMe.prototype.change = function() {
        if (this.position > this.count - 1) {
            this.position = 0;
            this.loopCount++;
            if (this.loopCount >= this.options.loopCount) {
                this.stop();
                return;
            }
        }
        this.changeWord(this.words[this.position]);
        this.position++;
        if (typeof this.options.onChange == "function") {
            this.options.onChange();
        }
    };
    ReplaceMe.prototype.stop = function() {
        this.running = false;
        this.position = this.loopCount = 0;
        this.pause();
        if (typeof this.options.onComplete == "function") {
            this.options.onComplete();
        }
    };
    ReplaceMe.prototype.pause = function() {
        clearTimeout(this.loop);
    };
    ReplaceMe.prototype.changeWord = function(word) {
        this.element.innerHTML = '<span class="' + this.options.animation + '" style="display:inline-block;">' + word + "</span>";
    };
    // If there is html tag inside string delete it
    ReplaceMe.prototype.escapeHTML = function(string) {
        var reg = /<\/?\w+\s*[^>]*>/g;
        if (reg.test(string) === true) {
            return string.replace(reg, "");
        }
        return string;
    };
    return ReplaceMe;
}();
module.exports = ReplaceMe;


/***/ }),

/***/ 9428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "St": function() { return /* binding */ fadeInAnimate; }
/* harmony export */ });
/* unused harmony exports slideInDownAnimate, zoomInAnimate */
var animation = function(param) {
    var name = param.name, delay = param.delay;
    return {
        animationName: name,
        animationDelay: delay,
        animationFillMode: "both",
        animationDuration: "700ms",
        animationDirection: "normal",
        animationTimingFunction: "ease"
    };
};
var slideInDownAnimate = function(delay) {
    return animation({
        name: "slideInDown",
        delay: delay
    });
};
var zoomInAnimate = function(delay) {
    return animation({
        name: "zoomIn",
        delay: delay
    });
};
var fadeInAnimate = function(delay) {
    return animation({
        name: "fadeIn",
        delay: delay
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (animation)));


/***/ })

}]);